<template>
  <div class="handwriting-sample-container">
    <img
      :src="imageUrl"
      alt="Handwriting sample"
      class="handwriting-image"
      v-if="imageUrl"
      @error="handleImageError"
    />
    <p v-if="!imageUrl" class="no-handwriting-message">No handwriting sample available for this subject</p>
  </div>
</template>

<script>
export default {
  name: 'HandwritingSample',
  computed: {
    imageUrl() {
      const subjectId = localStorage.getItem('currentSubjectId') || localStorage.getItem('subjectId');
      if (!subjectId) return null;

      const handwritingMap = {
        'ACTB117': 'ACTB117_003_002_000_SubmittedDrawing_25_01_17_09_53_29.png',
        'Actb118': 'Actb118_003_002_000_SubmittedDrawing_25_01_17_11_08_26.png',
        'Actb119': 'Actb119_003_002_000_SubmittedDrawing_25_01_17_13_13_33.png',
        'Actb120': 'Actb120_003_002_000_SubmittedDrawing_25_01_17_14_17_37.png',
        'ACTB126': 'ACTB126_003_002_000_SubmittedDrawing_25_02_14_12_23_34.png',
        'actb140': 'actb140_003_002_000_SubmittedDrawing_25_03_21_10_44_36.png',
        'ACTB198': 'ACTB198_003_002_000_SubmittedDrawing_24_12_13_10_24_09.png',
        'ACTB199': 'ACTB199_003_002_000_SubmittedDrawing_24_12_13_11_12_22.png',
        'ACTI109': 'ACTI109_003_002_000_SubmittedDrawing_24_12_12_11_42_54.png',
        'ACTI110': 'ACTI110_004_002_000_SubmittedDrawing_25_01_09_11_18_35.png',
        'ACTI111': 'ACTI111_004_002_000_SubmittedDrawing_25_01_09_10_45_56.png',
        'ACTI112': 'ACTI112_004_002_000_SubmittedDrawing_25_01_21_13_38_48.png',
        'Acti113': 'Acti113_004_002_000_SubmittedDrawing_25_01_24_10_01_59.png'
      };

      let filename = handwritingMap[subjectId];

      if (!filename) {
        const lowerSubjectId = subjectId.toLowerCase();
        const matchingKey = Object.keys(handwritingMap).find(key => key.toLowerCase() === lowerSubjectId);
        if (matchingKey) {
          filename = handwritingMap[matchingKey];
        }
      }

      if (!filename) return null;

      return `https://braingamecenter.s3.us-east-2.amazonaws.com/ACT_PILOTB_2024_10_pentagon_scoring/${filename}`;
    }
  },
  methods: {
    handleImageError(event) {
      console.error('Failed to load handwriting sample image:', event);
      event.target.style.display = 'none';
    }
  }
};
</script>

<style scoped>
.handwriting-sample-container {
  margin: 20px 0;
  text-align: center;
}

.handwriting-image {
  max-width: 100%;
  max-height: 400px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.no-handwriting-message {
  color: #666;
  font-style: italic;
}
</style>
